import React, { useMemo } from 'react'

import { IRealTimeQueryConfig, RTDReportTypes } from 'api/report/realTime/types'
import MissedChatsDrilldown from 'layouts/RealTimeDashboard/Drilldowns/MissedChats'
import QualifiedLeadsDrilldown from 'layouts/RealTimeDashboard/Drilldowns/QualifiedLeads'
import TeamStatusDrilldown from 'layouts/RealTimeDashboard/Drilldowns/TeamStatus'

export interface ModalContentProps {
  showTeamQualifiedLeads?: boolean
}

interface Props {
  title: string
  component: React.FC<ModalContentProps>
  dataOcWebId: string
  query: IRealTimeQueryConfig
  exportColumns: string[]
  exportKey: DrillDownExportKeys
  hasExport: boolean
  showTeamOnlyData?: boolean
}

export enum ModalType {
  MISSED_CHATS = 'RTDMissedChats',
  QUALIFIED_LEADS = 'RTDLeadsQualifiedChart',
  QUALIFIED_LEADS_TOTAL = 'RTDLeadsQualifiedTotal',
  TEAM_STATUS = 'RTDTeamStatus',
  TEAM_PERFORMANCE_SALES = 'RTDSalesTeamPerformance',
  TEAM_PERFORMANCE_SERVICE = 'RTDServiceTeamPerformance',
  TEAMMATE_PERFORMANCE_SALES = 'RTDSalesTeammatePerformance',
  TEAMMATE_PERFORMANCE_SERVICE = 'RTDServiceTeammatePerformance',
  NONE = '',
}

enum DrillDownExportKeys {
  TEAM = 'TEAM',
  AGENT = 'AGENT',
  END_USER = 'END_USER',
}

export const useDrilldownAndExportConfig = (): Record<string, Props> => {
  return useMemo(
    () => ({
      [ModalType.MISSED_CHATS]: {
        title: "Today's missed conversations",
        component: MissedChatsDrilldown,
        dataOcWebId: 'RTDMissedChatDrilldownTable',
        query: { metric: RTDReportTypes.MISSED_CHATS_SEARCH },
        exportColumns: [
          'contact',
          'company',
          'teammate',
          'team',
          'outcome',
          'time_to_first_response',
          'time',
          'conversation_link',
        ],
        hasExport: true,
        exportKey: DrillDownExportKeys.END_USER,
      },
      [ModalType.QUALIFIED_LEADS]: {
        title: "Today's qualified leads",
        component: QualifiedLeadsDrilldown,
        dataOcWebId: 'RTDQualifiedLeadsDrilldownTable',
        query: { metric: RTDReportTypes.LEADS_SEARCH },
        exportColumns: [
          'contact',
          'company',
          'teammate',
          'team',
          'qualified_by',
          'lead_score',
          'time',
          'conversation_link',
        ],
        hasExport: true,
        showTeamOnlyData: true,
        exportKey: DrillDownExportKeys.END_USER,
      },
      [ModalType.QUALIFIED_LEADS_TOTAL]: {
        title: "Today's qualified leads",
        component: QualifiedLeadsDrilldown,
        dataOcWebId: 'RTDQualifiedLeadsDrilldownTable',
        query: { metric: RTDReportTypes.LEADS_SEARCH },
        exportColumns: [
          'contact',
          'company',
          'teammate',
          'team',
          'qualified_by',
          'lead_score',
          'time',
          'conversation_link',
        ],
        hasExport: true,
        exportKey: DrillDownExportKeys.END_USER,
      },
      [ModalType.TEAM_STATUS]: {
        title: 'Current online and offline teammates',
        component: TeamStatusDrilldown,
        dataOcWebId: 'RTDTeamStatusDrilldownTable',
        query: { metric: '' },
        exportColumns: [],
        hasExport: false,
        exportKey: DrillDownExportKeys.AGENT,
      },
      [ModalType.TEAM_PERFORMANCE_SALES]: {
        title: 'Current online and offline teammates',
        component: TeamStatusDrilldown,
        dataOcWebId: 'RTDTeamStatusDrilldownTable',
        query: { metric: '' },
        exportColumns: [],
        hasExport: false,
        exportKey: DrillDownExportKeys.AGENT,
      },
    }),
    []
  )
}
